import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface LargeCategory {
  largeCategoryCd: string;
  largeCategoryCdName: string;
  middleCategory: MiddleCategory[];
}

export interface MiddleCategory {
  middleCategoryCd: string;
  middleCategoryCdName: string;
  middleCategoryCdMapping: string;
  smallCategoryAttribute: string;
  smallCategory?: SmallCategory[];
}

export interface SmallCategory {
  smallCategoryCd: string;
  smallCategoryCdName: string;
}

export interface SearchCategoryState {
  key: {
    userId: string;
    agencyCd: string[];
  };
  categories: LargeCategory[];
}

export const initialState: SearchCategoryState = {
    key: { userId: '', agencyCd: [] },
    categories: [],
};

export const SearchCategoryReducer = reducerWithInitialState(initialState)
  .case(actions.updateSearchCategory, (state: SearchCategoryState, payload: SearchCategoryState) => {
    return payload;
  });
